import { ContractMode } from '@/utils/Enumerations.js'
export default {
  tickets: [],
  loading: false,
  filteredTickets: [],
  postedTickets: [],
  contractMode: ContractMode.Logs,
  filters: {
    inTransit: {
      name: 'inTransit',
      icon: 'mdi-truck',
      isButton: true,
      active: true
    },
    weighedIn: {
      name: 'weighedIn',
      icon: 'mdi-weight',
      isButton: true,
      active: true
    },
    weighedOut: {
      name: 'weighedOut',
      icon: 'mdi-receipt-text-clock-outline',
      isButton: true,
      active: true
    },
    readyForPayment: {
      name: 'readyForPayment',
      icon: 'mdi-currency-usd',
      isButton: true,
      active: true
    },
    posted: {
      name: 'posted',
      icon: 'mdi-checkbox-marked-circle',
      isButton: true,
      active: false
    },
    internal: {
      name: 'internal',
      icon: 'mdi-home',
      isButton: true,
      active: false
    },
    missingImages: {
      name: 'missingImages',
      active: false,
      isButton: true,
      icon: 'mdi-image-off-outline'
    },
    dateRange: {
      name: 'dateRange',
      icon: 'mdi-calendar',
      isButton: true,
      active: false,
      startDate: undefined,
      endDate: undefined
    },
    advancedSearch: {
      name: 'advancedSearch',
      query: undefined,
      active: false
    },
    phrase: {
      name: 'phrase',
      active: false,
      icon: 'mdi-text',
      phrase: ''
    },
    contract: {
      name: 'contract',
      icon: 'mdi-altimeter',
      active: false,
      contractId: undefined
    },
    tract: {
      name: 'tract',
      icon: 'mdi-crosshairs-gps',
      active: false,
      tractId: undefined
    }
  }
}
